/**
 * All supported languages with recognizable input
 */
const languages = {
  'en-US': { // RFC 3066 level 2 identifier, also browser language header
    language: 'en', // language subtag
    country: 'US', // country subtag
    cultureCode: 1033, // Microsoft culture code: https://msdn.microsoft.com/en-us/library/ee796272,
    commonName: 'English' // language name in common English
  },
  'da-DK': {
    language: 'da',
    country: 'DK',
    cultureCode: 1030,
    commonName: 'Danish'
  },
  'fr-FR': {
    language: 'fr',
    country: 'FR',
    cultureCode: 1036,
    commonName: 'French'
  },
  'it-IT': {
    language: 'it',
    country: 'IT',
    cultureCode: 1040,
    commonName: 'Italian'
  },
  'pl-PL': {
    language: 'pl',
    country: 'PL',
    cultureCode: 1045,
    commonName: 'Polish'
  },
  'es-ES': {
    language: 'ed',
    country: 'ES',
    cultureCode: 3082,
    commonName: 'Spanish'
  },
  'bg-BG': {
    language: 'bg',
    country: 'BG',
    cultureCode: 1026,
    commonName: 'Bulgarian'
  },
  'nl-NL': {
    language: 'nl',
    country: 'NL',
    cultureCode: 1043,
    commonName: 'Dutch'
  },
  'de-DE': {
    language: 'de',
    country: 'DE',
    cultureCode: 1031,
    commonName: 'German'
  },
  'lv-LV': {
    language: 'lv',
    country: 'LV',
    cultureCode: 1062,
    commonName: 'Latvian'
  },
  'ro-RO': {
    language: 'ro',
    country: 'ro',
    cultureCode: 1048,
    commonName: 'Romanian'
  },
  'sv-SE': {
    language: 'sv',
    country: 'SE',
    cultureCode: 1053,
    commonName: 'Swedish'
  },
  'sv-FI': {
    language: 'sv',
    country: 'FN',
    cultureCode: 2077,
    commonName: 'Swedish - Finland'
  },
  'hr-HR': {
    language: 'hr',
    country: 'HR',
    cultureCode: 1050,
    commonName: 'Croatian'
  },
  'et-EE': {
    language: 'et',
    country: 'EE',
    cultureCode: 1061,
    commonName: 'Estonian'
  },
  'el-GR': {
    language: 'el',
    country: 'GR',
    cultureCode: 1032,
    commonName: 'Greek'
  },
  'lt-LT': {
    language: 'lt',
    country: 'LT',
    cultureCode: 1063,
    commonName: 'Lithuanian'
  },
  'sk-SK': {
    language: 'sk',
    country: 'SK',
    cultureCode: 1051,
    commonName: 'Slovak'
  },
  'tr-TR': {
    language: 'tr',
    country: 'TR',
    cultureCode: 1055,
    commonName: 'Turkish'
  },
  'cs-CZ': {
    language: 'cs',
    country: 'CZ',
    cultureCode: 1029,
    commonName: 'Czech'
  },
  'fi-FI': {
    language: 'fi',
    country: 'FI',
    cultureCode: 1035,
    commonName: 'Finnish'
  },
  'hu-HU': {
    language: 'hu',
    country: 'HU',
    cultureCode: 1038,
    commonName: 'Hungarian'
  },
  'mt-MT': {
    language: 'mt',
    country: 'MT',
    cultureCode: 1082,
    commonName: 'Maltese'
  },
  'sl-SI': {
    language: 'sl',
    country: 'SI',
    cultureCode: 1060,
    commonName: 'Slovenian'
  }
};

const resolvedLanguage = (input) => {
  if (!input) { return undefined; }

  if (languages[input]) {
    return input;
  }

  for (let id in languages) {
    if (languages.hasOwnProperty(id)) {
      let identifier = languages[id];

      if (identifier.language === input ||
        identifier.cultureCode === input || (identifier.cultureCode || '').toString() === input ||
        (typeof input === 'string' && identifier.commonName.toLowerCase() === input.toLowerCase())) {
        return id;
      }
    }
  }
  // fall back to language subtag only for not yet matched type 2 identifiers
  if (typeof input === 'string' && input[2] === '-') {
    const languageSubtag = input.substr(0, 2);
    const matchByLanguageSubtag = Object.keys(languages).find(languageId => languageSubtag === languageId.substr(0, 2));
    if (matchByLanguageSubtag) {
      return matchByLanguageSubtag;
    }
  }

  return undefined; // no default match desired
};

export default resolvedLanguage;
